import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

export default function ProjectTable({ projects }: { projects: any[] }) {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Active':
      case 'In Progress':
        return 'primary';
      case 'Completed':
        return 'success';
      case 'On Hold':
        return 'warning';
      default:
        return 'default';
    }
  };

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, flexShrink: 0 }}>
        Recent Projects
      </Typography>
      <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2, flex: 1, overflow: 'auto', minHeight: 0 }}>
        <Table sx={{ minWidth: 650 }} aria-label="projects table">
          <TableHead sx={{ bgcolor: 'background.paper' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Project Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Progress</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Timeline</TableCell>
              <TableCell align="right" sx={{ fontWeight: 600 }}>Budget</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {projects.slice(0, 5).map((project) => (
              <TableRow key={project.id} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {project.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip 
                    label={project.status} 
                    size="small" 
                    color={getStatusColor(project.status) as any} 
                    variant="outlined" 
                  />
                </TableCell>
                <TableCell sx={{ width: 150 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ width: '100%', mr: 1 }}>
                      <LinearProgress 
                        variant="determinate" 
                        value={project.progress} 
                        sx={{ height: 6, borderRadius: 3 }}
                      />
                    </Box>
                    <Box sx={{ minWidth: 35 }}>
                      <Typography variant="body2" color="text.secondary">{`${Math.round(project.progress)}%`}</Typography>
                    </Box>
                  </Box>
                </TableCell>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">
                    {project.startDate} - {project.endDate || 'TBD'}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    ${project.spentAmount.toLocaleString()}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

